

// NAVBAR FEATURES SUBMENU DATA
import earthIcon from '../../assets/earthIcon.svg'
import purpleEarth from '../../assets/purpleEarth.svg'
import syncmodelIcon from '../../assets/scyncmodel.svg'
import integrationIcon from '../../assets/integrationIcon.svg'
import devIcon from '../../assets/devIcon.svg'
import integrationorangeicon from "../../assets/integrationorangeIcon.svg"
import synciconHover from "../../assets/syncIconHover.svg"
import devIconHover from "../../assets/devIconHover.svg"
import persistence from "../../assets/persist.svg"
import perHover from "../../assets/perhover.svg"
import discord from "../../assets/disc-line.svg"
import discHover from "../../assets/disc-color.svg"


export const featureSubmenu = [
    {
      title: 'Multiplayer Kit',
      description: 'A robust architecture to build with zero backend code',
      icon:earthIcon,
      onHoverIcon:purpleEarth,
      href:"multiplayer"
    },
    
    {
      title: 'Sync’d Modules',
      description: 'Embeddable app modules that speed up development',
      icon:syncmodelIcon,
      onHoverIcon:synciconHover,
      href:"modules"

  
    },
    // {
    //   title: 'Hosting',
    //   description: 'Instantly deploy and share games globally',
    //   icon:devIcon,
    //   onHoverIcon:devIconHover,
    //   href:"hosting"
      
    // },
   //      {
   //    title: 'Integrations',
   //    description: 'Build with your favorite AI, Avatar and social tools',
   //    icon:integrationIcon,
   //    onHoverIcon:integrationorangeicon,
   // href:"integration"
      
  
   //  },
            {
      title: 'Persistence',
      description: 'Build Always On applications with persistent states',
      icon:persistence,
      onHoverIcon:perHover,
   href:"persistence"
      
  
    },
    {
      title: 'Discord Kit',
      description: 'Deploy Activities with managed multiplayer servers',
      icon:discord,
      onHoverIcon:discHover,
   href:"discord"
      
  
    },

    
  ];




//   BUILT FOR THE NEXT GENERATION SECTION DATA

import cursorIcon from "../../assets/examples/cursor.png"
import textIcon from "../../assets/examples/text.png"

import canvasIcon from "../../assets/examples/canvas.png"
import open from "../../assets/open.png"
import poki from "../../assets/poki.png"
import disc from "../../assets/disc-home.png"
export const builtForNextGenerationCardsData = [
    {
      id: 1,
      img1Src: canvasIcon,
      title: "Creative Apps",
      desc: "Build features like live canvases. Draw together, paint freely.",
    },
    {
      id: 3,
      img1Src: textIcon,
      title: "Productivity Apps",
      desc: "Work together! Build collaborative editing features for faster workflows.",
    },
    {
      id: 2,
      img1Src: cursorIcon,
      title: "Collaboration Apps",
      desc: "Allow users to see each other in your application by building live cursors.",
    },
    {
      id: 4,
      img1Src: open,
      title: "AI Games",
      desc: "Build games with limitless content powered with AI"
    },
   {
      id: 5,
      img1Src: disc,
      title: "Discord Games",
      desc: "Build games that brings 100s together from across the world"
    },
  ];
  

// GET STARTED SECTION DATA
import unityIcon from "../../assets/unityIcon.svg"
import threejsIcon from "../../assets/threejsIcon.svg"
import godotIcon from "../../assets/godotIcon.svg"
import cocosIcon from "../../assets/cocosIcon.svg"
import pixijsIcon from "../../assets/PixijsIcon.svg"
import playcanvasIcon from "../../assets/playcanvasIcon.svg"
import reactIcon from "../../assets/React-icon.svg"
import webxrIcon from "../../assets/webxrIcon.svg"
import phaserIcon from "../../assets/phaserIcon.svg"
import vueIcon from "../../assets/vue.svg"
import nextIcon from "../../assets/next.svg"
import angularIcon from "../../assets/angular.svg"


export const techCards = [
    { icon: reactIcon, title: 'React',href:"https://docs.joinplayroom.com/usage" },
    { icon: nextIcon, title: 'Next.js',href:"https://docs.joinplayroom.com/frameworks/web/nextjs" },
    { icon: vueIcon, title: 'Vue',href:"https://docs.joinplayroom.com/frameworks/web/vue" },
    { icon: angularIcon, title: 'Angular',href:"https://docs.joinplayroom.com/frameworks/web/angular" },
    { icon: pixijsIcon, title: 'PixiJs' ,href:"https://docs.joinplayroom.com/usage/pixijs"},
    { icon: threejsIcon, title: 'Threejs', href:"https://docs.joinplayroom.com/usage/threejs    " },
    { icon: webxrIcon, title: 'WebXR',href:"https://docs.joinplayroom.com/usage" },
    { icon: unityIcon, title: 'Unity',href:"https://docs.joinplayroom.com/usage/unity" },
    { icon: playcanvasIcon, title: 'Playcanvas',href:"https://docs.joinplayroom.com/usage/playcanvas    " },
    { icon: godotIcon, title: 'Godot',href:"https://docs.joinplayroom.com/usage/godot" },
    { icon: cocosIcon, title: 'Cocos',href:"https://docs.joinplayroom.com/usage" },
    { icon: phaserIcon, title: 'Phaser',href:"https://docs.joinplayroom.com/usage/phaser" },
  ];
